import { mapCollection } from '../../utils/collection.utils';
import { parseNumber } from '../../utils/number.utils';
import { ToolManagementValidation } from '../tool-management-validation';
import { UserBuilder } from './user.builder';

export class ToolManagementValidationBuilder {
  static fromJson(json) {
    return (json)
      ? new ToolManagementValidation(
        json.hash,
        parseNumber(json.date),
        parseNumber(json.quantity),
        json.isSent,
        json.isRebuild,
        UserBuilder.fromJson(json.user),
        json.toolManagementHash,
        json.toolManagementName,
        parseNumber(json.toolManagementStock),
        parseNumber(json.toolManagementRequestQuantity),
        parseNumber(json.toolManagementOrderQuantity),
        json.toolManagementErpCode,
        json.toolManagementOptionHash,
        json.toolManagementOptionName,
        json.toolManagementOptionStockNumber,
        parseNumber(json.toolManagementOptionRequestQuantity),
        parseNumber(json.toolManagementOptionOrderQuantity),
      )
      : null;
  }

  static fromList(list) {
    return mapCollection(ToolManagementValidationBuilder.fromJson, list);
  }

}



// WEBPACK FOOTER //
// /var/www/borneo/prod/borneo_app/src/app/core/models/builders/tool-management-validation.builder.ts